<template>
  <BaseIcon
    :width="width"
    :height="height"
    box="0 0 72 72"
    :color="color"
    title="Logo Facebook"
  >
    <!-- eslint-disable max-len -->
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 36.201C0 54.099 12.999 68.982 30 72V45.999H21V36H30V27.999C30 18.999 35.799 14.001 44.001 14.001C46.599 14.001 49.401 14.4 51.999 14.799V24H47.4C42.999 24 42 26.199 42 29.001V36H51.6L50.001 45.999H42V72C59.001 68.982 72 54.102 72 36.201C72 16.29 55.8 0 36 0C16.2 0 0 16.29 0 36.201Z"
    />
  </BaseIcon>
</template>

<script>
import BaseIcon from './BaseIcon.vue';

export default {
  components: {
    BaseIcon,
  },
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: [Number, String],
      default: 72,
    },
    height: {
      type: [Number, String],
      default: 72,
    },
  },
};
</script>
